import { render, staticRenderFns } from "./PointProductList.vue?vue&type=template&id=24eaf94a&scoped=true"
import script from "./PointProductList.vue?vue&type=script&lang=js"
export * from "./PointProductList.vue?vue&type=script&lang=js"
import style0 from "./PointProductList.vue?vue&type=style&index=0&id=24eaf94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eaf94a",
  null
  
)

export default component.exports